module.exports = __webpack_public_path__ + "static/media/acct_update-profile.cb0eb401.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/acct_update-profile.md
// module id = 1079
// module chunks = 0